<h1 mat-dialog-title>This website uses cookies.</h1>
<div mat-dialog-content>
  <p>To ensure you get the best experience possible this website uses cookies. <a href="https://www.cookiesandyou.com/">Learn more</a></p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="true" class="add-button" cdkFocusInitial>Accept</button>
</div>